import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faLinkedinIn, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import styled from 'styled-components';

const Section = styled.section`
  background: linear-gradient(45deg, #003580,#07b6f2);
  
  padding: 50px 20px;
  font-family: "Poppins", system-ui;
  text-align: center;
  color:white;
  position: relative;
  overflow: hidden;

  @media (max-width: 1024px) {
    padding: 40px 20px;
  }

  @media (max-width: 768px) {
    padding: 30px 15px;
  }
`;

const Title = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 20px;
  font-weight: 700;

  @media (max-width: 1024px) {
    font-size: 2rem;
    margin-bottom: 15px;
  }

  @media (max-width: 768px) {
    font-size: 1.75rem;
    margin-bottom: 10px;
    text-align: justify;
    line-height: 1.6;
  }
`;

const SubTitle = styled.p`
  font-size: 1.2rem;
  margin-bottom: 30px;

  @media (max-width: 1024px) {
    font-size: 1rem;
    margin-bottom: 20px;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
    margin-bottom: 20px;
    text-align: justify;
    line-height: 1.71;
  }
`;

const Button = styled.button`
  background-color: white;
  color: #501a96;
  border: none;
  border-radius: 50px;
  padding: 12px 40px;
  font-size: 1.1rem;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover {
    background-color: #f0f0f0;
  }

  @media (max-width: 1024px) {
    padding: 10px 35px;
    font-size: 1rem;
  }

  @media (max-width: 768px) {
    padding: 8px 30px;
    font-size: 0.9rem;
  }
`;

const BackgroundCircle = styled.div`
  position: absolute;
  border-radius: 50%;
 
  filter: blur(90px);

  &:nth-child(1) {
    width: 200px;
    height: 200px;
    top: -50px;
    left: -50px;
  }

  &:nth-child(2) {
    width: 150px;
    height: 150px;
    top: 20px;
    right: 50px;
  }

  &:nth-child(3) {
    width: 100px;
    height: 100px;
    bottom: -30px;
    left: 50%;
    transform: translateX(-50%);
  }

  @media (max-width: 768px) {
    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(3) {
      display: none;
    }
  }
`;

const SocialMediaContainer = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: center;
  gap: 20px;
`;

const SocialIcon = styled.a`
  color: white;
  font-size: 1.5rem;
  transition: color 0.3s;

  &:hover {
    color: #d1d1d1;
  }

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const Letsgetintouch = () => {
  return (
    <Section>
      <BackgroundCircle />
      <BackgroundCircle />
      <BackgroundCircle />
      <Title>Enhance Your Business with Our Services</Title>
      <SubTitle>
        Discover how our innovative solutions can drive success for your company. Let’s discuss how we can help you achieve your goals.
      </SubTitle>
      <NavLink to={"/contact#contactusform"}>
        <Button>Contact Us</Button>
      </NavLink>
      <SocialMediaContainer>
      <SocialIcon href="https://www.linkedin.com/company/nextech-plm-solutions/" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faLinkedinIn} />
        </SocialIcon>
        <SocialIcon href="https://wa.me/9970166224" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faWhatsapp} />
        </SocialIcon>
        <SocialIcon href="https://www.facebook.com/share/vNf8TQB9UWD12RVY/?mibextid=qi2Omg" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faFacebookF} />
        </SocialIcon>
        <SocialIcon href="https://www.instagram.com/nextech_plm_solutions?igsh=MTUwOWtvM3h2cHJrdw==" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} />
        </SocialIcon>
       
      </SocialMediaContainer>
    </Section>
  );
};

export default Letsgetintouch;
